import { render, staticRenderFns } from "./PicklrDetails.vue?vue&type=template&id=c5aa207c&scoped=true&"
import script from "./PicklrDetails.vue?vue&type=script&lang=ts&"
export * from "./PicklrDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PicklrDetails.vue?vue&type=style&index=0&id=c5aa207c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aa207c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5aa207c')) {
      api.createRecord('c5aa207c', component.options)
    } else {
      api.reload('c5aa207c', component.options)
    }
    module.hot.accept("./PicklrDetails.vue?vue&type=template&id=c5aa207c&scoped=true&", function () {
      api.rerender('c5aa207c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PicklrDetails.vue"
export default component.exports